import React from 'react';
import styles from './style.module.css';

const WEIGHTS = {
  thin: 100,
  extralight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};

const Text = ({
  children,
  variant = 'body1',
  weight = 'regular',
  color = 'default',
  align = 'left',
  className,
  as: Component = 'p',
  ...props
}) => {
  const weightValue = typeof weight === 'number' ? weight : WEIGHTS[weight] || WEIGHTS.regular;

  const classNames = [
    styles.text,
    styles[variant],
    styles[`color-${color}`],
    styles[`align-${align}`],
    className
  ].filter(Boolean).join(' ');

  return (
    <Component 
      className={classNames}
      style={{ 
        ...props.style,
        fontWeight: weightValue 
      }}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Text; 